import { faFilePdf } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { useTableCoreFunctions } from "../../Hooks/useTableCoreFunctions";
import { IDocumentDetail } from "../../Interfaces/IDocumentDetail";
import { IReportDocumentRecord } from "../../Interfaces/IReportDocumentRecord";
import { GLOBALS } from "../../Models/Globals";
import { NoRecordsMessage } from "../NoRecordsMessage/NoRecordsMessage";
import { SecDocDetailRender } from "../SecDocDetailRender/SecDocDetailRender";
import { HeaderTableCell } from "../Styled/HeaderTableCell";
import { YearFilter } from "../YearFilter/YearFilter";




export const SecFillingsRender = () => {

    const { SrvContext } = useContext(ServiceContext);
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();

    const [currentDocs, setCurrentDocs] = useState<IReportDocumentRecord[]>([]);
    const [filteredDocs, setFilteredDocs] = useState<IReportDocumentRecord[]>([]);
    const [currentYearFilter, setCurrentYearFilter] = useState<number>(moment().year());
    const [showDocumentDetail, setShowDocumentDetail] = useState<boolean>(false);
    const [currentDocumentDetail, setCurrentDocumentDetail] = useState<IDocumentDetail[]>([]);
    const [currentDocumentType, setCurrentDocumentType] = useState<string>("");

    const [
        page,
        rowsPerPage,
        handleChangePage,
        renderActivoIcon,
        handleChangeRowsPerPage,
        formatFecha
    ] = useTableCoreFunctions();

    const Initialize = async () => {

        const docs = SrvContext.WindowData.sccoDocsRender.DocsReportToRender;
        setFilteredDocs(docs);
        setCurrentDocs(docs);
        await i18n.changeLanguage(SrvContext.WindowData.sccoDocsRender.idiomaCode);
        SetIsLoading(false);

    };


    const LoadDetail = async (documentId: number, docType: string) => {

        console.info("Document to show", documentId, docType);
        const docDetail = await SrvContext.GetDocumentDetails(documentId);
        console.info("Detalles del documento", docDetail);
        if (docDetail.length == 1) {
            window.open(
                docDetail[0].url_padre, "_blank", 'dowload'
            );
            return;
        }

        if (docDetail.length > 1) {

            setCurrentDocumentType(docType);
            setCurrentDocumentDetail(docDetail);
            setShowDocumentDetail(true);

        }

    };


    const ShowDocumentDetail = (documentId: number, docType: string) => () => {

        LoadDetail(documentId, docType);

    };


    const renderButtonLink = (documentId: number, docType: string) => {

        if (documentId) {

            return (
                <TableCell align="center">
                    <Button onClick={ShowDocumentDetail(documentId, docType)}>
                        <Typography variant="body1">
                            <FontAwesomeIcon icon={faFilePdf} size="2x" />
                        </Typography>
                    </Button>
                </TableCell>
            );

        }

        return (
            <TableCell align="center">-</TableCell>
        );

    };

    const showTable = () => {

        setShowDocumentDetail(false);

    };

    const onYearChanged = (selectedValue: number) => {

        setCurrentYearFilter(selectedValue);
        if (selectedValue == GLOBALS.NO_SELECTED_OPTION) {

            setFilteredDocs(currentDocs);

        } else {

            setFilteredDocs(currentDocs.filter((doc, index) => {
                return doc.years == selectedValue;
            }));

        }

    };

    useEffect(() => {

        Initialize();

    }, []);

    return (
        <Grid container spacing={3} xs={12}>
            {
                isLoading ? (
                    <LinearProgress />
                ) : (
                    currentDocs.length == 0 ? (
                        <NoRecordsMessage />
                    ) : (
                        <Grid item container xs={12} md={12} spacing={3}>
                            {
                                showDocumentDetail ? (
                                    <SecDocDetailRender
                                        docs={currentDocumentDetail}
                                        docType={currentDocumentType}
                                        OnBack={showTable}
                                    />
                                ) : (
                                    <>
                                        <Grid item container xs={12} spacing={3}>
                                            <Grid item xs={12} md={4}>
                                                <YearFilter
                                                    OnSelectionChange={onYearChanged}
                                                // PreviousYear={currentYearFilter.toString()}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TableContainer component={Paper}>
                                                <Table sx={{ minWidth: 700 }}>
                                                    <TableHead>
                                                        <TableRow className="borderedHeader">
                                                            <HeaderTableCell align="center"></HeaderTableCell>
                                                            <HeaderTableCell align="center"></HeaderTableCell>
                                                            <HeaderTableCell align="center" colSpan={3} className="headerLRBorders">{t('label-10Q')}</HeaderTableCell>
                                                            <HeaderTableCell align="center" colSpan={4}></HeaderTableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <HeaderTableCell align="center">{t('label-year')}</HeaderTableCell>
                                                            <HeaderTableCell align="center">{t('label-8k')}</HeaderTableCell>
                                                            <HeaderTableCell align="center" className="headerLRBorders">{t('label-1Q')}</HeaderTableCell>
                                                            <HeaderTableCell align="center" className="headerLRBorders">{t('label-2Q')}</HeaderTableCell>
                                                            <HeaderTableCell align="center" className="headerLRBorders">{t('label-3Q')}</HeaderTableCell>
                                                            <HeaderTableCell align="center">{t('label-10K')}</HeaderTableCell>
                                                            <HeaderTableCell align="center">{t('label-proxy')}</HeaderTableCell>
                                                            <HeaderTableCell align="center">{t('label-annual-report')}</HeaderTableCell>
                                                            <HeaderTableCell align="center">{t('label-other')}</HeaderTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            filteredDocs.length == 0 ? (
                                                                <TableRow>
                                                                    <TableCell colSpan={9}>{t('label-no-records')}</TableCell>
                                                                </TableRow>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        filteredDocs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                            .map((doc, index) => (
                                                                                <TableRow hover key={`table-row-${index}`}>
                                                                                    <TableCell align="center">{doc.years}</TableCell>
                                                                                    {renderButtonLink(doc.id_8K, GLOBALS.DOC_TYPE_8K)}
                                                                                    {renderButtonLink(doc.id_1Q, GLOBALS.DOC_TYPE_1Q)}
                                                                                    {renderButtonLink(doc.id_2Q, GLOBALS.DOC_TYPE_2Q)}
                                                                                    {renderButtonLink(doc.id_3Q, GLOBALS.DOC_TYPE_3Q)}
                                                                                    {renderButtonLink(doc.id_10k, GLOBALS.DOC_TYPE_10K)}
                                                                                    {renderButtonLink(doc.id_Proxy, GLOBALS.DOC_TYPE_PROXY)}
                                                                                    {renderButtonLink(doc.id_AnnualReport, GLOBALS.DOC_TYPE_ANNUAL)}
                                                                                    {renderButtonLink(doc.id_Other, GLOBALS.DOC_TYPE_OTHER)}
                                                                                </TableRow>
                                                                            ))
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination
                                                rowsPerPageOptions={[25, 50, 75, 100]}
                                                component="div"
                                                count={filteredDocs.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </Grid>
                                    </>
                                )
                            }
                        </Grid>
                    )
                )
            }
        </Grid>
    );

};
